export const lowValueError = "Value must be over $1";
export const noDecimalError = "Value can't have cents";
export const isNaNError = "Value can't be NaN";
export const isAssetValueValid = (value) => {
    if (isNaN(value)) {
        return isNaNError;
    }
    if (value < 1) {
        return lowValueError;
    }
    if (Math.trunc(value) !== value) {
        return noDecimalError;
    }
    return true;
};
//# sourceMappingURL=isAssetValueValid.js.map